import React, { Component } from "react";
import Footer from "../../common/Footer.js";
import ClientSideNav from "../../common/ClientSideNav.js";
import TopNav from "../../common/TopNav.js";
import * as moment from "moment";
import debounce from "lodash.debounce";
import download from "downloadjs";
import { Table } from "react-bootstrap";
import requireAuth from "../../hoc/requireAuth";
import Swal from "sweetalert2/dist/sweetalert2.js";
import authorizeClient from "../../hoc/authorizeClient";
import NotAccessablePage from "../NotAccessablePage.js";
//import NotAccessablePage from "./../pages/NotAccessablePage.js";
import { getNewSortOrder } from "../../helpers.js";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/js/src/collapse.js";
import Loader from "react-loader-spinner";
import DateRangePicker from "react-bootstrap-daterangepicker";
import { connect } from "react-redux";
import "bootstrap-daterangepicker/daterangepicker.css";
import {
  castToDefaultDateFormat,
  castToServerDateFormat,
} from "../../settings/index";
import { changeClientDateFilter } from "../../store/actions/filterActions";
import { withAlert } from "react-alert";
import InfrigementStatusDropdownComponent from "./../../components/InfrigementStatusDropdownComponent";
import "../../pages/client/ecommerceDashboard.css";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import SellerDashboardCard from "../../components/charts/SellerDashboard.jsx";

class UniqueSellerDashboard extends Component {
  constructor(props) {
    super(props);
    this.getEcommerceData = debounce(this.getEcommerceData.bind(this), 1000);
    this.handleSelect = this.handleSelect.bind(this);
    this.state = {
      sorting: {
        sortBy: "",
        sortIconClass: "sort-icon-nutral",
        sortOrder: "",
      },
      sellerName: "",
      authorised: true,
      domainUniqueSites: [],
      visibleRecords: "",
      dropdownCount: false,
      domains: [],
      pagination: {
        page: 1,
        nextPage: 1,
        prevPage: null,
        hasNextPage: true,
        hasPrevPage: false,
        pagingCounter: 1,
        totalDocs: null,
        totalPages: null,
      },
      perPage: 10,
      hasMoreDomainData: true,
      isLoading: false,
      locale: { format: "DD/MM/YYYY" },
      isToggled: true,
      // data[0].bar
      bar: [
        {
          bar: [
            {
              Company: 0,
              label: "April 2025",
            },
          ],
          totalDocs: 0,
        },
        {
          bar: [
            {
              Brand: 0,
              label: "Company",
            },
          ],
          totalDocs: 0,
        },
      ],
    };
    window.onscroll = debounce(async () => {
      const {
        getEcommerceData,
        state: { hasMoreDomainData, dropdownCount },
      } = this;

      if (!hasMoreDomainData) {
        return;
      }

      // Calculate the scroll position
      const scrollPosition =
        window.innerHeight + document.documentElement.scrollTop;

      // Check if scrolled to the bottom
      if (scrollPosition === document.documentElement.offsetHeight) {
        if (dropdownCount) {
          // Set dropdownCount to false to fetch all data
          this.setState({ dropdownCount: false });
        } else {
          // Paginate the data
          await getEcommerceData();
        }
      }
    }, 100);
  }

  changeSorting(sortBy) {
    this.setState((prevState) => {
      const { sortOrder, classPostFix } = getNewSortOrder(prevState);

      return {
        sorting: {
          sortBy,
          sortIconClass: `sort-icon-${classPostFix}`,
          sortOrder,
        },
      };
    });
  }

  componentDidUpdate(prevProps, prevState) {
    if (
      prevState.sorting.sortBy !== this.state.sorting.sortBy ||
      prevState.sorting.sortOrder !== this.state.sorting.sortOrder ||
      prevProps.selectedBrand !== this.props.selectedBrand ||
      prevProps.clientEcommerceFilter !== this.props.clientEcommerceFilter ||
      prevProps.clientDateFilter !== this.props.clientDateFilter ||
      prevProps.location?.state?.notification !==
        this.props.location?.state?.notification
    ) {
      this.getEcommerceData(true);
    }

    if (prevState.domains.length !== this.state.domains.length) {
      this.setState({ visibleRecords: this.state.domains.length }, () => {});
    }
  }

  async downloadExcel() {
    if (this.state.pagination.totalDocs > 25000) {
      Swal.fire(
        "More than 25,000 records cannot be downloaded. Please contact administrator.",
        "",
        "warning",
      );
    } else {
      const options = {
        headers: {
          "Content-Type":
            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          "Content-disposition": 'attachment; filename=ecommerce.xlsx"',
        },
      };

      let reqData = {
        startDate: castToServerDateFormat(
          this.props.clientDateFilter.startDate,
        ),
        endDate: castToServerDateFormat(this.props.clientDateFilter.endDate),
        module: "e-commerce",
        ...this.props?.clientEcommerceFilter,
      };

      if (this.props.selectedBrand?.id) {
        reqData.brand = this.props.selectedBrand?.id;
      }

      if (this.props.selectedCompany?.id) {
        reqData.clientCompanyId = this.props.selectedCompany?.id;
      }

      await window.axios
        .get(
          "/ecommerce/download-xls",
          {
            params: reqData,
            responseType: "blob",
            timeout: 100000,
          },
          options,
        )
        .then((res) => {
          download(res.data, "ecommerce.xls");
        });
    }
  }

  async getEcommerceData(reArrangeRecords = false) {
    const options = {
      headers: { "Content-Type": "application/json" },
    };

    let reqData = {
      dropdownCount: this.state.dropdownCount,
      sortBy: this.state.sorting.sortBy,
      sortOrder: this.state.sorting.sortOrder,
      page: reArrangeRecords ? 1 : this.state.pagination.nextPage, // Use nextPage for pagination
      perPage: this.state.perPage,
      startDate: castToServerDateFormat(this.props.clientDateFilter.startDate),
      endDate: castToServerDateFormat(this.props.clientDateFilter.endDate),
      ...this.props.clientEcommerceFilter,
    };

    if (this.props.location?.state?.notification) {
      reqData.notification = this.props.location?.state?.notification;
    }

    if (this.props.selectedBrand?.id) {
      reqData.brand = this.props.selectedBrand?.id;
    }

    if (this.props.selectedCompany?.id) {
      reqData.clientCompanyId = this.props.selectedCompany?.id;
    }

    if (this.state.sellerName) {
      reqData.sellerName = this.state.sellerName;
    }

    reqData.module = "e-commerce";
    reqData.allData = this.state.isToggled;
    this.setState({ isLoading: true });

    try {
      const res = await window.axios.get(
        "/ecommerce/uniqueSellerData",
        { params: reqData },
        options,
      );

      //let domainData = res.data.data[0].docs;
      let domainData = res.data.data;
      let barData = [];
      barData.push(res.data.data[1]);
      barData.push(res.data.data[2]);

      if (reArrangeRecords) {
        this.setState({
          domains: domainData[0].docs,
          pagination: {
            page: domainData[0].page,
            nextPage: domainData[0].nextPage,
            prevPage: domainData[0].prevPage,
            hasNextPage: domainData[0].hasNextPage,
            hasPrevPage: domainData[0].hasPrevPage,
            pagingCounter: domainData[0].pagingCounter,
            totalDocs: domainData[0].totalDocs,
            totalPages: domainData[0].totalPages,
          },
          hasMoreDomainData: domainData[0].hasNextPage,
          isLoading: false,
          bar: barData,
        });
        return;
      }

      if (reqData.dropdownCount) {
        domainData = res.data.docs; // Only update with the current response data
      } else if (this.state.domains.length > 0) {
        domainData = this.state.domains.concat(domainData); // Append new data to existing data
      }

      this.setState({
        domains: domainData[0].docs,
        pagination: {
          page: domainData[0].page,
          nextPage: domainData[0].nextPage,
          prevPage: domainData[0].prevPage,
          hasNextPage: domainData[0].hasNextPage,
          hasPrevPage: domainData[0].hasPrevPage,
          pagingCounter: domainData[0].pagingCounter,
          totalDocs: domainData[0].totalDocs,
          totalPages: domainData[0].totalPages,
        },
        hasMoreDomainData: domainData[0].hasNextPage,
        isLoading: false,
        bar: barData,
      });
      this.setState({ domainUniqueSites: res.data.domainUniqueSites });
    } catch (error) {
      // Handle error
      this.setState({ isLoading: false });
      console.error("Error fetching ecommerce data:", error);
    }
  }

  getDateFilters() {
    return {
      startDate: moment(this.props.clientDateFilter.startDate),
      endDate: moment(this.props.clientDateFilter.endDate),
      locale: this.state.locale,
    };
  }

  handleCallback = async (event, picker) => {
    this.props.dispatch(
      changeClientDateFilter({
        startDate: picker.startDate,
        endDate: picker.endDate,
      }),
    );
  };

  renderLoader() {
    if (this.state.isLoading) {
      return (
        <div className="text-center">
          <Loader
            type="ThreeDots"
            color="#00BFFF"
            height={10}
            width={200}
            timeout={5000} //3 secs
          />
        </div>
      );
    }
  }

  handleToggle = () => {
    this.setState(
      (prevState) => ({
        isToggled: !prevState.isToggled,
      }),
      () => {
        // Runs after isToggled is updated
        this.getEcommerceData(true); // You may want reArrangeRecords = true
      },
    );
  };

  componentDidMount() {
    const params = new URLSearchParams(this.props.location.search);
    const sellerName = params.get("sellerName") || "";
    this.setState({ sellerName });
    this.getEcommerceData();
    this.setState({ visibleRecords: this.state.domains.length }, () => {});
  }

  updateClientCommentInArray(value, key) {
    let records = this.state.domains;

    records[key]["clientComment"] = value;

    this.setState(() => ({
      domains: records,
    }));
  }

  async updateClientCommentToDatabase(key) {
    let clientComment = this.state.domains[key]["clientComment"];
    let infrigementId = this.state.domains[key]["id"];

    if (!clientComment) {
      return;
    }

    const options = {
      headers: { "Content-Type": "application/json" },
    };

    await window.axios
      .post(
        `/ecommerce/${infrigementId}/update-client-comment`,
        {
          clientComment,
        },
        options,
      )
      .then((res) => {
        this.props.alert.success("Comment upated successfully.");
      })
      .catch(function (error) {
        this.props.alert.error(error.response.data.message);
      });
  }

  handleSelect(countValue) {
    this.setState({ dropdownCount: countValue });
    this.getEcommerceData();
  }

  printPaginationInfo() {
    let totalDocs = this.state.pagination.totalDocs
      ? this.state.pagination.totalDocs
      : 0;
    let visibleRecords = 0;

    if (totalDocs) {
      visibleRecords =
        totalDocs > this.state.perPage * this.state.pagination.page
          ? this.state.perPage * this.state.pagination.page
          : totalDocs;
    }

    return (
      <>
        <div className="d-flex align-items-center">
          <span className="text-uppercase page-subtitle">
            Showing <strong>{this.state.visibleRecords}</strong> records of{" "}
            <strong>{totalDocs}</strong>
          </span>
          <div className="dropdown ml-3">
            <button
              className="btn btn-secondary dropdown-toggle custom-dropdown-button"
              type="button"
              id="dropdownMenuButton"
              data-toggle="dropdown"
              aria-haspopup="true"
              aria-expanded="false"
              style={{
                backgroundColor: "white",
                width: "130px",
                color: "black", // Add the color property for text visibility
                height: "20px", // Adjust the height as per your requirements
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                lineHeight: "1",
              }}
            >
              {this.state.visibleRecords} Records
            </button>
            <div className="dropdown-menu" aria-labelledby="dropdownMenuButton">
              <a
                className="dropdown-item"
                href="#"
                onClick={() => this.handleSelect(10)}
              >
                Show 10 records
              </a>
              <a
                className="dropdown-item"
                href="#"
                onClick={() => this.handleSelect(20)}
              >
                Show 20 records
              </a>
              <a
                className="dropdown-item"
                href="#"
                onClick={() => this.handleSelect(50)}
              >
                Show 50 records
              </a>
            </div>
          </div>
        </div>
      </>
    );
  }

  renderHtml() {
    const { isToggled } = this.state;

    const containerStyle = {
      width: "60px",
      height: "30px",
      backgroundColor: isToggled ? "#4caf50" : "#ccc",
      borderRadius: "30px",
      position: "relative",
      cursor: "pointer",
      transition: "background-color 0.3s",
    };

    const sliderStyle = {
      width: "26px",
      height: "26px",
      backgroundColor: "white",
      borderRadius: "50%",
      position: "absolute",
      top: "2px",
      left: isToggled ? "32px" : "2px",
      transition: "left 0.3s ease",
      boxShadow: "0 0 4px rgba(0, 0, 0, 0.2)",
    };
    if (!this.props.selectedBrand?.platforms?.eCommerce) {
      return <NotAccessablePage />;
    }

    return (
      <div className="row">
        <ClientSideNav domainUniqueSites={this.state.domainUniqueSites} />

        <main className="main-content col-lg-10 col-md-9 col-sm-12 p-0 offset-lg-2 offset-md-3">
          <TopNav />
          <div className="row justify-content-end">
            <div
              className="col-6 d-flex justify-content-end align-items-center m-1"
              style={{ gap: "10px", flexWrap: "wrap" }}
            >
              {/* Left Label - Demo Brand */}
              <span
                className="text-nowrap"
                style={{
                  color: this.state.isToggled ? "#000" : "#dc3545", // highlight if not toggled
                  fontWeight: this.state.isToggled ? "normal" : "bold",
                }}
              >
                Demo Brand
              </span>

              {/* Toggle Switch */}
              <div
                style={{
                  width: "60px",
                  height: "30px",
                  backgroundColor: "#dc3545",
                  borderRadius: "30px",
                  cursor: "pointer",
                  transition: "background-color 0.3s",
                  padding: "2px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: this.state.isToggled
                    ? "flex-end"
                    : "flex-start",
                  position: "relative",
                  flexShrink: 0,
                }}
                onClick={this.handleToggle}
              >
                <div
                  style={{
                    width: "26px",
                    height: "26px",
                    backgroundColor: "#fff",
                    borderRadius: "50%",
                    boxShadow: "0 0 2px rgba(0,0,0,0.3)",
                  }}
                ></div>
              </div>

              {/* Right Label - All LdotR */}
              <span
                className="text-nowrap"
                style={{
                  color: this.state.isToggled ? "#dc3545" : "#000", // highlight if toggled
                  fontWeight: this.state.isToggled ? "bold" : "normal",
                  marginRight: "30px",
                }}
              >
                All LdotR
              </span>

              {/* Reporting Date */}
              <span className="text-nowrap">
                <strong>Reporting Date:</strong>
              </span>
              <DateRangePicker
                onApply={this.handleCallback}
                initialSettings={this.getDateFilters()}
                alwaysShowCalendars={true}
              >
                <input className="form-control w-auto" />
              </DateRangePicker>
            </div>
          </div>

          <SellerDashboardCard
            title={this.state.sellerName}
            data={this.state.bar}
            link=""
            children=""
            useAccordion={true}
          />
          <div className="main-content-container container-fluid px-4">
            <div className="page-header row no-gutters py-4">
              <div className="col-12">
                <div className="row">
                  <div className="col-5 text-sm-left mb-0">
                    <span className="text-uppercase page-subtitle">
                      {this.state.sellerName}
                    </span>
                    {this.printPaginationInfo()}
                  </div>
                  <div className="col-2 text-sm-right mb-0">
                    {this.renderLoader()}
                  </div>
                </div>
              </div>
            </div>

            <div id="scrollableDiv" style={{ overflow: "hidden" }}>
              <div className="row">
                <div className="col">
                  {/* table here */}
                  <Table className="table-responsive">
                    <thead className="uppercase-text">
                      <tr>
                        <th scope="col" width="3%" className="border-0">
                          {" "}
                          #
                        </th>
                        <th
                          width="3%"
                          scope="col"
                          className="border-0 text-uppercase"
                        >
                          Image
                        </th>
                        <th
                          width="10%"
                          scope="col"
                          onClick={(e) => this.changeSorting("title")}
                          className={`border-0 text-uppercase ${
                            this.state.sorting.sortBy === "title"
                              ? this.state.sorting.sortIconClass + " sort-icon"
                              : "sort-icon sort-icon-nutral"
                          }`}
                        >
                          Title
                        </th>
                        <th
                          width="10%"
                          scope="col"
                          onClick={(e) => this.changeSorting("site")}
                          className={`border-0 text-uppercase ${
                            this.state.sorting.sortBy === "site"
                              ? this.state.sorting.sortIconClass + " sort-icon"
                              : "sort-icon sort-icon-nutral"
                          }`}
                        >
                          Site
                        </th>
                        <th
                          width="10%"
                          scope="col"
                          onClick={(e) => this.changeSorting("reportingDate")}
                          className={`border-0 text-uppercase ${
                            this.state.sorting.sortBy === "reportingDate"
                              ? this.state.sorting.sortIconClass + " sort-icon"
                              : "sort-icon sort-icon-nutral"
                          }`}
                        >
                          Reporting Date
                        </th>
                        <th
                          width="10%"
                          scope="col"
                          onClick={(e) => this.changeSorting("priority")}
                          className={`border-0 text-uppercase ${
                            this.state.sorting.sortBy === "priority"
                              ? this.state.sorting.sortIconClass + " sort-icon"
                              : "sort-icon sort-icon-nutral"
                          }`}
                        >
                          Priority
                        </th>
                        <th
                          width="10%"
                          scope="col"
                          onClick={(e) => this.changeSorting("status")}
                          className={`border-0 text-uppercase ${
                            this.state.sorting.sortBy === "status"
                              ? this.state.sorting.sortIconClass + " sort-icon"
                              : "sort-icon sort-icon-nutral"
                          }`}
                        >
                          Status
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {this.state.domains.map((domain, key) => {
                        // Your code logic for each domain

                        return (
                          <>
                            <tr
                              key={domain?.id}
                              data-toggle="collapse"
                              data-target={".multi-collapse" + key}
                              aria-controls={"multiCollapseExample" + key}
                            >
                              <td>{key + 1}</td>
                              <td>
                                <img
                                  className="user-avatar"
                                  width="50"
                                  src={domain.imageUrl}
                                  alt={domain.title}
                                />
                              </td>
                              <td>
                                {" "}
                                <a
                                  href={domain.url}
                                  target="_blank"
                                  title={domain.title}
                                  className="bind-width"
                                >
                                  <p
                                    title={domain.title}
                                    className="bind-width"
                                  >
                                    {domain.title}
                                  </p>
                                </a>
                              </td>
                              <td>
                                <p className="bind-width" title={domain.site}>
                                  {domain.site}
                                </p>{" "}
                              </td>
                              <td>
                                {" "}
                                <p
                                  title={castToDefaultDateFormat(
                                    domain.reportingDate,
                                  )}
                                  className="bind-width"
                                >
                                  {castToDefaultDateFormat(
                                    domain.reportingDate,
                                  )}
                                </p>
                              </td>
                              <td>{domain.priority}</td>
                              <td>
                                <InfrigementStatusDropdownComponent
                                  selectedInfrigemnt={domain}
                                  selectedInfrigemntIndex={key}
                                  infrigementType="e-commerce"
                                />
                              </td>
                            </tr>
                            <tr
                              className={"collapse multi-collapse" + key}
                              id={"multiCollapseExample" + key}
                            >
                              <td colSpan={10}>
                                <div className="row ">
                                  <div
                                    className="col-md-3 "
                                    // style={{ marginBottom: "-250px" }}
                                    style={{ height: "10px" }}
                                  >
                                    <img
                                      data-toggle="modal"
                                      width="200"
                                      data-target={"#myModal" + key}
                                      src={domain.imageUrl}
                                      className="mr-2"
                                      alt="Cinque Terre"
                                      style={{ marginBottom: "20px" }}
                                    />

                                    <div class="input-box">
                                      <span className="text-muted d-block mb-2">
                                        Reason
                                      </span>
                                      <textarea
                                        value={domain.reason}
                                        className="input-content"
                                      ></textarea>
                                      <span className="text-muted d-block mb-2">
                                        Reason Code
                                      </span>
                                      <OverlayTrigger
                                        placement="left"
                                        overlay={
                                          <Tooltip id="tooltip">
                                            {domain.reasonCode}
                                          </Tooltip>
                                        }
                                      >
                                        <input
                                          type="text"
                                          value={domain.reasonCode}
                                          disabled
                                          className="form-control"
                                          placeholder="Username"
                                          aria-label="Username"
                                          aria-describedby="basic-addon1"
                                        />
                                      </OverlayTrigger>

                                      <br />
                                      <br />
                                    </div>
                                  </div>

                                  <div className="col-md-9">
                                    <div className="row">
                                      <div className="col-md-6">
                                        <div className="form-group">
                                          <span className="text-muted d-block mb-2">
                                            Title
                                          </span>
                                          <OverlayTrigger
                                            placement="left"
                                            overlay={
                                              <Tooltip id="tooltip">
                                                {domain.title}
                                              </Tooltip>
                                            }
                                          >
                                            <input
                                              type="text"
                                              value={domain.title}
                                              disabled
                                              className="form-control"
                                              placeholder="Username"
                                              aria-label="Username"
                                              aria-describedby="basic-addon1"
                                            />
                                          </OverlayTrigger>
                                        </div>
                                      </div>
                                      <div className="col-md-6">
                                        <div className="form-group">
                                          <span
                                            className="text-muted d-block mb-2"
                                            data-toggle="tooltip"
                                            data-html="true"
                                            title={domain.site}
                                          >
                                            Site
                                          </span>
                                          <OverlayTrigger
                                            placement="left"
                                            overlay={
                                              <Tooltip id="tooltip">
                                                {domain.site}
                                              </Tooltip>
                                            }
                                          >
                                            <input
                                              type="text"
                                              value={domain.site}
                                              disabled
                                              className="form-control"
                                              placeholder="Username"
                                              aria-label="Username"
                                              aria-describedby="basic-addon1"
                                            />
                                          </OverlayTrigger>
                                        </div>
                                      </div>
                                      <div className="col-md-6">
                                        <div className="form-group">
                                          <span className="text-muted d-block mb-2">
                                            Price
                                          </span>{" "}
                                          <OverlayTrigger
                                            placement="left"
                                            overlay={
                                              <Tooltip id="tooltip">
                                                {domain.price}
                                              </Tooltip>
                                            }
                                          >
                                            <input
                                              type="text"
                                              value={domain.price}
                                              disabled
                                              className="form-control"
                                              placeholder=""
                                              aria-label="Username"
                                              aria-describedby="basic-addon1"
                                            />
                                          </OverlayTrigger>
                                        </div>
                                      </div>
                                      <div className="col-md-6">
                                        <div className="form-group">
                                          <span className="text-muted d-block mb-2">
                                            MRP
                                          </span>{" "}
                                          <OverlayTrigger
                                            placement="left"
                                            overlay={
                                              <Tooltip id="tooltip">
                                                {domain.mrp}
                                              </Tooltip>
                                            }
                                          >
                                            <input
                                              type="text"
                                              value={domain.mrp}
                                              disabled
                                              className="form-control"
                                              placeholder=""
                                              aria-label="Username"
                                              aria-describedby="basic-addon1"
                                            />
                                          </OverlayTrigger>
                                        </div>
                                      </div>
                                      <div className="col-md-6">
                                        <div className="form-group">
                                          <span className="text-muted d-block mb-2">
                                            Priority
                                          </span>
                                          <OverlayTrigger
                                            placement="left"
                                            overlay={
                                              <Tooltip id="tooltip">
                                                {domain.priority}
                                              </Tooltip>
                                            }
                                          >
                                            <input
                                              type="text"
                                              value={domain.priority}
                                              disabled
                                              className="form-control"
                                              placeholder="Username"
                                              aria-label="Username"
                                              aria-describedby="basic-addon1"
                                            />
                                          </OverlayTrigger>
                                        </div>
                                      </div>
                                      <div className="col-md-6">
                                        <div className="form-group">
                                          <span className="text-muted d-block mb-2">
                                            Brand Name
                                          </span>
                                          <OverlayTrigger
                                            placement="left"
                                            overlay={
                                              <Tooltip id="tooltip">
                                                {domain.brand.brandName}
                                              </Tooltip>
                                            }
                                          >
                                            <input
                                              type="text"
                                              value={domain.brand.brandName}
                                              disabled
                                              className="form-control"
                                              placeholder=""
                                              aria-label="Username"
                                              aria-describedby="basic-addon1"
                                            />
                                          </OverlayTrigger>
                                        </div>
                                      </div>
                                    </div>

                                    <div className="row">
                                      <div className="col-md-12">
                                        <h5>Seller</h5>
                                      </div>

                                      <div className="col-md-6">
                                        <div className="form-group">
                                          <span className="text-muted d-block mb-2">
                                            Username
                                          </span>
                                          <OverlayTrigger
                                            placement="left"
                                            overlay={
                                              <Tooltip id="tooltip">
                                                {domain.username}
                                              </Tooltip>
                                            }
                                          >
                                            <input
                                              type="text"
                                              value={domain.username}
                                              disabled
                                              className="form-control"
                                              placeholder="Username"
                                              aria-label="Username"
                                              aria-describedby="basic-addon1"
                                            />
                                          </OverlayTrigger>
                                        </div>
                                      </div>
                                      <div className="col-md-6">
                                        <div className="form-group">
                                          <span className="text-muted d-block mb-2">
                                            Seller Rating
                                          </span>
                                          <OverlayTrigger
                                            placement="left"
                                            overlay={
                                              <Tooltip id="tooltip">
                                                {domain.sellerRating}
                                              </Tooltip>
                                            }
                                          >
                                            <input
                                              type="text"
                                              value={domain?.sellerRating}
                                              disabled
                                              className="form-control"
                                              placeholder=""
                                              aria-label="Username"
                                              aria-describedby="basic-addon1"
                                            />
                                          </OverlayTrigger>
                                        </div>
                                      </div>
                                      <div className="col-md-6">
                                        <div className="form-group">
                                          <span className="text-muted d-block mb-2">
                                            Id
                                          </span>
                                          <OverlayTrigger
                                            placement="left"
                                            overlay={
                                              <Tooltip id="tooltip">
                                                {domain.storeId}
                                              </Tooltip>
                                            }
                                          >
                                            <input
                                              type="text"
                                              value={domain.storeId}
                                              disabled
                                              className="form-control"
                                              placeholder=""
                                              aria-label="Username"
                                              aria-describedby="basic-addon1"
                                            />
                                          </OverlayTrigger>
                                        </div>
                                      </div>
                                      <div className="col-md-6">
                                        <div className="form-group">
                                          <span className="text-muted d-block mb-2">
                                            Address
                                          </span>
                                          <OverlayTrigger
                                            placement="left"
                                            overlay={
                                              <Tooltip id="tooltip">
                                                {domain.address}
                                              </Tooltip>
                                            }
                                          >
                                            <input
                                              type="text"
                                              value={domain.address}
                                              disabled
                                              className="form-control"
                                              placeholder="Username"
                                              aria-label="Username"
                                              aria-describedby="basic-addon1"
                                            />
                                          </OverlayTrigger>
                                        </div>
                                      </div>
                                      <div className="col-md-6">
                                        <div className="form-group">
                                          <span className="text-muted d-block mb-2">
                                            City
                                          </span>
                                          <OverlayTrigger
                                            placement="left"
                                            overlay={
                                              <Tooltip id="tooltip">
                                                {domain.city}
                                              </Tooltip>
                                            }
                                          >
                                            <input
                                              type="text"
                                              value={domain.city}
                                              disabled
                                              className="form-control"
                                              placeholder="Username"
                                              aria-label="Username"
                                              aria-describedby="basic-addon1"
                                            />
                                          </OverlayTrigger>
                                        </div>
                                      </div>
                                      <div className="col-md-6">
                                        <div className="form-group">
                                          <span className="text-muted d-block mb-2">
                                            Country
                                          </span>
                                          <OverlayTrigger
                                            placement="left"
                                            overlay={
                                              <Tooltip id="tooltip">
                                                {domain.country}
                                              </Tooltip>
                                            }
                                          >
                                            <input
                                              type="text"
                                              value={domain.country}
                                              disabled
                                              className="form-control"
                                              placeholder="Username"
                                              aria-label="Username"
                                              aria-describedby="basic-addon1"
                                            />
                                          </OverlayTrigger>
                                        </div>
                                      </div>
                                    </div>

                                    {/* ------------------------ comment section end here --------------------------- */}
                                    <div className="row">
                                      <div className="col-md-12">
                                        <span className="text-muted d-block mb-2">
                                          Comment
                                        </span>
                                        <div className="form-group d-flex align-items-center">
                                          <button
                                            style={{ marginRight: "10px" }}
                                            onClick={(e) =>
                                              this.updateClientCommentToDatabase(
                                                key,
                                              )
                                            }
                                            className="btn btn-success"
                                          >
                                            Update comment
                                          </button>

                                          <div className="flex-grow-1">
                                            <textarea
                                              onChange={(e) =>
                                                this.updateClientCommentInArray(
                                                  e.target.value,
                                                  key,
                                                )
                                              }
                                              className="form-control"
                                              value={
                                                domain?.clientComment
                                                  ?.comment || ""
                                              }
                                            />
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                    {/* ------------------------ comment section end here --------------------------- */}
                                  </div>
                                </div>
                              </td>
                            </tr>
                            <div className="modal" id={"myModal" + key}>
                              <div className="modal-dialog modal-800">
                                <div className="modal-content">
                                  <div className="modal-header">
                                    <h4 className="modal-title">Image</h4>
                                    <button
                                      type="button"
                                      className="close"
                                      data-dismiss="modal"
                                    >
                                      &times;
                                    </button>
                                  </div>
                                  <div className="modal-body">
                                    <img
                                      src={domain.imageUrl}
                                      width="100%"
                                      className="img-responsive"
                                      alt="Cinque Terre"
                                    />
                                  </div>
                                </div>
                              </div>
                            </div>
                          </>
                        );
                      })}
                    </tbody>
                  </Table>
                </div>
              </div>
            </div>
          </div>

          <Footer />
        </main>
      </div>
    );
  }

  render() {
    return <>{this.renderHtml()}</>;
  }
}

const mapStateToProps = (state) => ({
  clientEcommerceFilter: state.clientEcommerceFilter,
  clientDateFilter: state.clientDateFilter,
});

export default withAlert()(
  connect(mapStateToProps)(authorizeClient(requireAuth(UniqueSellerDashboard))),
);
